import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import {
  BLACK, BLACK_300, BLUE, GRAY1, GREEN, CANCELLED,
} from 'constants/colors';
import { MensalVisaoGeral } from 'types/Relatorios/Mensal';

// Cores fixas por série (Figma): PLD max/min em cinza (faixa de referência),
// PLD em preto, as demais séries de comparação em cores de marca — o mesmo
// mapeamento é usado pelas bolinhas de legenda da tabela (ver `SERIE_COR` em
// index.tsx), espelhando o padrão já usado no Intersemanal/Semanal.
// tema: dados-inicio — cor de série (o ThemedECharts e a bolinha da tabela adaptam no escuro)
export const SERIE_COR: Record<string, string> = {
  'PLD max': BLACK_300,
  'PLD min': GRAY1,
  PLD: BLACK,
  '2006/2007': BLUE,
  PREVCONSENSO: GREEN,
};

const PALETA_FALLBACK = [BLUE, GREEN, BLACK, GRAY1, BLACK_300];
// tema: dados-fim

interface Props { data: MensalVisaoGeral; }

/**
 * Além do envelope PLD max/min (área cinza, igual ao Intersemanal/Semanal), o
 * Figma do Mensal mostra uma faixa vermelha sólida sobreposta ao gráfico —
 * sem legenda visível no print, inferida como uma banda de referência
 * regulatória (`data.faixa`, ver types/Relatorios/Mensal). Renderizada via
 * `markArea` fixo (não é uma série com dados por período).
 */
export default function VisaoGeralChart({ data }: Props) {
  const { faixa } = data;

  const option = {
    legend: { data: data.series.map((s) => s.nome) },
    xAxis: { type: 'category', data: data.periodos },
    yAxis: { type: 'value', name: data.unidade },
    series: [
      ...data.series.map((s, i) => ({
        name: s.nome,
        type: 'line',
        data: s.valores,
        color: SERIE_COR[s.nome] ?? PALETA_FALLBACK[i % PALETA_FALLBACK.length],
        ...(s.nome === 'PLD max' || s.nome === 'PLD min' ? { areaStyle: { opacity: 0.15 } } : {}),
      })),
      {
        name: faixa.nome,
        type: 'line',
        data: [],
        markArea: {
          silent: true,
          itemStyle: { color: CANCELLED, opacity: 0.15 },
          data: [[{ yAxis: faixa.minimo }, { yAxis: faixa.maximo }]],
        },
      },
    ],
    tooltip: { trigger: 'axis' },
    grid: { left: '10%', right: '5%', containLabel: true },
  };

  return <ReactECharts option={option} style={{ height: 320 }} />;
}
